import { mergeQueryKeys } from "@lukemorales/query-key-factory";

import { amplifyAuthQueryKeys } from "./amplify/auth";
import { bidQueryKeys } from "./catalog/bids";
import { categoryQueryKeys } from "./catalog/categories";
import { eventQueryKeys } from "./catalog/events";
import { matchScoredBallsQueryKey } from "./catalog/matchScoredBalls";
import { menuHierarchyQueryKeys } from "./catalog/menuHiearchies";
import { followedCategoriesListQueryKeys } from "./catalog/mePreferenceCategories";
import { followedEventsListQueryKeys } from "./catalog/mePreferenceEvents";
import { followedProductsListQueryKeys } from "./catalog/mePreferenceProducts";
import { productQueryKeys } from "./catalog/products";
import { bidCostsQueryKeys } from "./finance/bidCosts";
import { countryQueryKeys } from "./finance/countries";
import { customerQueryKeys } from "./finance/customers";
import { orderQueryKeys } from "./finance/orders";
import { paymentsQueryKeys } from "./finance/payments";
import { tokensQueryKeys } from "./finance/tokens";
import { framingOrdersQueryKeys } from "./framing/orders";
import { presetsQueryKeys } from "./framing/presets";
import { framingPreviewQueryKeys } from "./framing/previews";
import { meQueryKeys } from "./identity/me";
import { storyblokQueryKeys } from "./storyblok";
import { articleQueryKeys } from "./storyblok/articles";

export const queries = mergeQueryKeys(
  meQueryKeys,

  productQueryKeys,
  matchScoredBallsQueryKey,
  bidQueryKeys,
  eventQueryKeys,
  categoryQueryKeys,
  menuHierarchyQueryKeys,
  followedCategoriesListQueryKeys,
  followedEventsListQueryKeys,
  followedProductsListQueryKeys,

  customerQueryKeys,
  orderQueryKeys,
  paymentsQueryKeys,
  bidCostsQueryKeys,
  countryQueryKeys,
  articleQueryKeys,
  presetsQueryKeys,
  framingPreviewQueryKeys,
  framingOrdersQueryKeys,
  storyblokQueryKeys,
  tokensQueryKeys,

  amplifyAuthQueryKeys,
);
